import { FIND_PAYMENT_BY_ELECTRONIC_DOCUMENT } from "..";
import { apiInstance } from "../config/apiInstance";

export const getPaymentByElectronicDocument = (id: string) => {
    return apiInstance.get(`${FIND_PAYMENT_BY_ELECTRONIC_DOCUMENT}/${id}`);
}
